import {h, Component} from 'preact';
import Renderer from '../canvas/renderer';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import designService from '../service/designService';
import designDomain from '../domain/designDomain';
import {getRevisionContent} from "../service/revisionService";
import {trailingZero} from "../util";

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export default @connect(reduce, actions)
class AsideRevisions extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      revisions: [],
    }
  }

  componentDidMount() {
    this.setState({isMemberLoading: true});
    designService.getDesignRevisions(this.props.designId).then(response => {
      this.setState({revisions: response.data.map(revision => new designDomain.Revision(revision))});
      this.setState({isLoading: false});
    })
  }

  showPreview(revision) {
    Renderer.previewRevision(revision.html);
    this.props.setVersionPreview(true, revision);

    if (this.props.onRevisionChange) {
      this.props.onRevisionChange();
    }
  }

  previewRevision(revision) {
    this.state.revisions.forEach(rev => rev.isActive = false);
    revision.isActive = true;

    if (revision.html) {
      this.showPreview(revision);
    } else {
      getRevisionContent(revision).then(resp => {
        revision.html = resp.data;
        this.showPreview(revision);
      });
    }
  }

  render(props, state) {
    return (
      <div id="app-aside-revisions" className="aside-text">
        <div className="scroller no-top pad">

          {!props.hideTitle && <h3>Saved Versions</h3>}

          <ul className="revisions">
            {state.revisions.map(revision => {
              const date = new Date(revision.updatedDate);

              return (
                <li key={revision.id} className={'revision ' + (revision.isActive ? 'active ' : '')}>
                  <h5>Saved {date.getDate()} {MONTHS[date.getMonth()]} at {trailingZero(date.getHours())}:{trailingZero(date.getMinutes())} </h5>
                  {!revision.isActive &&
                  <div>
                    <a className={'btn primary xs'} onClick={() => this.previewRevision(revision)}>Preview</a>
                  </div>}
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }
}
